'use strict';

function isValid(input, pattern) {
    var expression = new RegExp(pattern);
    return expression.test(input);
}

class RegexDirective {
    restrict = 'A';
    require = 'ngModel';

    link(scope, element, attr, ngModelCtrl) {
        var regex = scope.$eval(attr.regex);

        ngModelCtrl.$parsers.push(function (viewValue) {
            if (attr.regexEnabled && !scope.$eval(attr.regexEnabled)) {
                return viewValue;
            }
            var valid = isValid(viewValue, regex);
            ngModelCtrl.$setValidity('regex', valid);
            if (valid) {
                return viewValue;
            }
            return undefined;
        });

        if (attr.regexEnabled) {
            scope.$watch(
                () => scope.$eval(attr.regexEnabled),
                (newValue) => {
                    if (!newValue) {
                        ngModelCtrl.$setValidity('regex', true);
                    } else {
                        ngModelCtrl.$setValidity('regex', isValid(ngModelCtrl.$viewValue, regex));
                    }
                }
            );
        }
    }
}

export let regex:any = () => new RegexDirective();


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/regex.directive.ts